<template>
  <a
    v-if="isExternalLink"
    :href="url"
    @click="(event) => sendEvent(event)"
  >
    <slot />
  </a>
  <router-link
    v-else
    v-slot="{ href, navigate }"
    v-bind="$props"
    custom
  >
    <a
      v-bind="$attrs"
      :href="href"
      @click="(event) => handleClick(event, navigate)"
    >
      <slot />
    </a>
  </router-link>
</template>

<script setup lang="ts">
import { RouterLinkProps } from 'vue-router';

defineOptions({ inheritAttrs: false });
defineProps<Omit<RouterLinkProps, 'tag' | 'event'> & { url?: string; isExternalLink?: boolean }>();
const emit = defineEmits<{
  (e: 'click', value: MouseEvent): void;
}>();

const sendEvent = (event: MouseEvent) => {
  emit('click', event);
};

const handleClick = async (event: MouseEvent, navigate: (event: MouseEvent) => Promise<void>) => {
  sendEvent(event);
  await navigate(event);
};
</script>
